import { gql } from '@apollo/client';


export const QUESTION_FRAGMENT = gql`
  fragment QuestionFields on Question {
    _id
    key 
    defaultNextQuestionKey
    question        
    type
    uiDesign
    description
    image
    feature {
      _id
    }
    survey {
      _id
      type
    }
    nextQuestionDependsOnSurveyResponse
    dynamicNextQuestionKeys
    answersAreDynamic
    answersDependOnSurveyResponses
    jumpBackKeys
    answers(withDynamicAnswers: $withDynamicAnswers, surveyResponses: $surveyResponses) {
      _id
      key
      wording
      nextQuestionKey
      featureChoice {
        _id
      }
      meta {
        key 
        value
      }
    }
    order
    range {
      intervals {
        minValue
        maxValue
        label {
          name
        }
      }
      stepSize
      defaultValue
    }
    skippable
  }
`;

export const SURVEY_FRAGMENT = gql`
  fragment SurveyFields on Survey {
    _id
    title
    shortDescription
    longDescription
    displayInfo
    estimatedTime
    type
    isTree
    image
    designSystemColor
    humanReadableId
    formulas{
      feature 
    }
  }
`;

export const GET_ONBOARDING_SURVEY = gql`
  query onboardingSurvey {
    onboardingSurvey {
      _id
      type
    }
  }
`;

export const GET_QUESTIONS = gql`
  ${QUESTION_FRAGMENT}
  query getQuestions($survey: String!) {
    questionsOfSurvey(
      survey: $survey
    ) {
       ...QuestionFields
    }
  }
`;

export const GET_QUESTION_BY_ID = gql`
  ${QUESTION_FRAGMENT}
  query question($id: String!, $withDynamicAnswers: Boolean, $surveyResponses: [SurveyResponse!]) {
    question(
      id: $id
    ) {
       ...QuestionFields
    }
  }
`;

export const GET_DYNAMIC_NEXT_QUESTION = gql`
  ${QUESTION_FRAGMENT}
  query question($input:DynamicNextQuestionInput!, $surveyResponses: [SurveyResponse!]!, $withDynamicAnswers: Boolean) {
    question:getDynamicNextQuestion(input:$input, surveyResponses:$surveyResponses, withDynamicAnswers:$withDynamicAnswers) {
      ...QuestionFields
    }
  }
`;


export const getPresetSurveysQuery = () => gql`
  query getSurveys {
    surveys(criteria:{
      filters: {
        or: [
          { type: {operation: EQ, value: "matching"} },
          { type: {operation: EQ, value: "wpoInstantHelp"} },
          { type: {operation: EQ, value: "wpoScheduling"} }
        ]
      }
    }) {
      items {
        type
        _id
      }
    }
  }
`;

export const MATCHING_SURVEY = gql`
  query surveymatching {
    matchingSurvey{
        _id
    }
  }
`;

export const GET_SURVEY = gql`
  ${SURVEY_FRAGMENT}
  query survey($id: String!) {
    survey(id: $id) {
      ...SurveyFields
    }
  }
`;

export const GET_SURVEY_WITH_QUESTIONS = gql`
  ${QUESTION_FRAGMENT}
  ${SURVEY_FRAGMENT}
  query survey($id: String!,$withDynamicAnswers: Boolean, $surveyResponses: [SurveyResponse!]) {
    survey(id: $id) {
      ...SurveyFields
      questions {
        ...QuestionFields
      }
    }
  }
`;


export const GET_DASHBOARD_SURVEY = gql`
  query dashboardSurvey {
    dashboardSurvey {
      _id
      type
    }
  }
`;


/** a survey plays inside a session: the session to open for a survey id */
export const SESSION_FOR_SURVEY = gql`
  query sessionForSurvey($surveyId: String!) {
    sessionForSurvey(surveyId: $surveyId) {
      _id
      sessionType
    }
  }`;
